export const DATAGROUPS = [
  "name",
  "details",
  "lad",
  "combined",
  "region",
  "retail",
  "pcon"
];
